/*
 * @Author: withease-partner+cao@hashdash-group.com
 * @Description: the frame page of 「成功的按钮：边角是圆的有背景颜色的按钮」
 */
<template>
  <div class="backnextbutton-container">
    <div class="container-by">
      <cNoBgButton class="btn-list" text="戻る" @clickbtn="goBack"></cNoBgButton>
      <cRoundButton
        class="btn-list"
        :disabled="disabled"
        text="次へ"
        @clickbtn="goNext"
      ></cRoundButton>
    </div>
  </div>
</template>


<script>
export default {
  props: ['disabled'],
  methods: {
    goNext() {
      if (!this.disabled) {
        this.$emit('clickNext');
      }
    },
    goBack() {
      this.$emit('clickBack');
    }
  }
};
</script>

<style lang="less"  scoped>
.backnextbutton-container {
  width: 100%;
  background: #ffffff;
  display: flex;
  justify-content: center;
  .container-by{
    width: 100%;
    max-width: 6.8rem;
    height: 1rem;
    //padding: 0 0.3rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .btn-list {
      width: 47%;
    }
  }

}
@media screen and (max-width:750px){
  .container-by{
    padding: 0 0.2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Button/cBackNextButton.vue